import { useEffect, FC, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AuthClient from "../api/AuthClient";
import { routes } from "../routes/routes";
import RefreshButton from "../components/RefreshToUpdateData/RefreshToUpdateButton";
import { PartiesContext } from "../GlobalContext/partiesContext";
import { LoadingAnimationContext } from "../GlobalContext/loadingAnimation";
import MyPartiesContent from "./MyPartiesContent";
import { useMyParties } from "../hooks/useServerDataQueries";

interface MyPartiesProps {
  SetMyPartiesCount: (length: number) => void;
}
const MyParties: FC<MyPartiesProps> = ({ SetMyPartiesCount }) => {

  const authClient = useMemo(() => new AuthClient(), []);
  const isLoggedIn = authClient.isLoggedIn();

  const { myPartiesInfo, setMyPartiesInfoContextData } = useContext(PartiesContext);
  const { hasLoadedOnce, setHasLoadedOnce } = useContext(LoadingAnimationContext);
  const {
    data: queriedParties = [],
    isError,
    isFetching,
    isLoading,
    isSuccess,
    refetch,
  } = useMyParties();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(routes.Login);
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (isSuccess) {
      setMyPartiesInfoContextData(queriedParties);
      setHasLoadedOnce(true);
    }
  }, [isSuccess, queriedParties, setHasLoadedOnce, setMyPartiesInfoContextData]);

  useEffect(() => {
    if (isError) {
      setHasLoadedOnce(true);
    }
  }, [isError, setHasLoadedOnce]);

  const handleButtonClick = () => {
    void refetch();
  };

  const requeststate = isFetching || isLoading ? "loading" : isError ? "error" : "idle";
  const isLoadingParties = !hasLoadedOnce && (isLoading || isFetching);

  return (
    <>
      <div className="mb-3 refreshRequestContainer">
        <RefreshButton requestState={requeststate} onClickHandler={handleButtonClick} />
      </div>
      <MyPartiesContent
        isLoadingParties={isLoadingParties}
        myPartiesInfo={myPartiesInfo}
        SetMyPartiesCount={SetMyPartiesCount}
      />
    </>
  );
};

export default MyParties;

